export function createBaseUrl(route: string, queryParams?: string) {
    route = route.replace(/^\//, '')
    return `${process.env.REACT_APP_API_URL}/${route}${
        queryParams ? `?${queryParams}` : ''
    }`
}
